<template>
    <b-container fluid="">
        <b-row>
            <div class="col-sm-9 mt-3">
                <label for="" class="form-label">Nombre</label>
                <input type="text" id="campo_nombre_materiales" class="form-control form-control-sm" v-model="nombre_material">
            </div>
            <div class="col-sm-3 mt-5">
                <button type="button" v-if="permisos['inventarios.rayo.materiales']?.borrar || datos_usuario.parametros.roles.includes('ROOT')" class="btn btn-sm btn-outline-dark btn-block" @click="guardar">Agregar</button>
                <button v-else type="button" disabled class="btn btn-sm btn-outline-dark btn-block">Agregar</button>
            </div>
            <div class="col-sm-12 mt-3">
                <div class="marco_tabla_materiales">
                    <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                        <thead>
                            <tr>
                                <th style="width: 90%;">
                                    Nombre
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in materiales" :key="index">
                                <td>
                                    {{ item.nombre_material }}
                                </td>
                                <td style="text-align: center;">
                                    <button type="button" 
                                        v-if="permisos['inventarios.rayo.materiales']?.borrar || datos_usuario.parametros.roles.includes('ROOT')"
                                        style="font-size: 9px;margin-right: 5px;"
                                        class="btn btn-sm btn-outline-dark" 
                                        @click="eliminar(item.documentId)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                    <button type="button" 
                                        v-else
                                        style="font-size: 9px;margin-right: 5px;"
                                        class="btn btn-sm btn-outline-dark" 
                                        disabled>
                                        <i class="fas fa-trash"></i>
                                    </button>
                                    
                                    <button type="button" 
                                        v-if="permisos['inventarios.rayo.materiales']?.actualizar || datos_usuario.parametros.roles.includes('ROOT')"
                                        style="font-size: 9px;" 
                                        class="btn btn-sm btn-outline-dark"
                                        @click="abrir_modal_editar(item)">
                                        <i class="fas fa-pen"></i>
                                    </button>
                                    <button type="button" 
                                        v-else
                                        style="font-size: 9px;" 
                                        class="btn btn-sm btn-outline-dark"
                                        disabled>
                                        <i class="fas fa-pen"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </b-row>

        <Actualizar v-if="modal_editar" :item="item" v-on:salir="cerrar_modal_editar" />

    </b-container>
</template>

<script>
    import { minix, pregunta } from '@/components/functions/alertas';
    import { mapActions, mapState } from 'vuex';

    import Actualizar from './ModalEditar.vue'

    export default {
        name: 'ListaMateriales',
        computed: {
            ...mapState(['materiales', 'permisos', 'datos_usuario'])
        },
        components: {
            Actualizar
        },
        data() {
            return {
                nombre_material: '',
                modal_editar: false,
                item: {}
            }
        },
        methods: {

            async guardar() {
                if (this.nombre_material == '') {
                    minix({ icon: 'error', mensaje: 'El campo nombre no puede estar vacio', tiempo: 3000 })
                } else {
                    let f = {
                        api: `materiales`,
                        formulario: {
                            nombre_material: this.nombre_material.toUpperCase().trim()
                        }
                    }

                    await this.guardar_data(f)
                    await this.obtener_materiales()
                    this.nombre_material = ''
                    this.item = {}

                    document.getElementById('campo_nombre_materiales').focus()
                }
            },
            abrir_modal_editar(item) {
                this.item = item
                this.modal_editar = true
            },
            cerrar_modal_editar() {
                this.modal_editar = false
            },
            async eliminar(id) {
                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {

                        let f = {
                            api: `materiales/${id}`,
                        }

                        await this.borrar_data(f)
                        await this.obtener_materiales()

                    }
                })
            },
            ...mapActions(['guardar_data', 'obtener_materiales', 'borrar_data'])
        },
        mounted() {
            this.obtener_materiales()
        }
    }
</script>

<style>
    .marco_tabla_materiales {
        width: 100%;
        height: calc(100vh - 250px);
        overflow: auto;
    }
</style>